import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/proctor-dashboard',
        component: () => import('@/pages/proctor-dashboard/ProctorDashboard.vue'),
        props: true,
        name: 'Proctor Dashboard',
        children: [
            {
                name: 'proctor-dashboard-quiz-lobby',
                path: '',
                component: () => import('@/components/proctor-dashboard/QuizLobby.vue'),
                meta: {
                    title: 'Proctor Dashboard',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) =>
                        gateKeeper.userHasPermission("create another user's quiz attempt") ||
                        gateKeeper.userHasGroupPermission("create another user's quiz attempt"),
                },
                props: false,
            },
        ],
    },
];
